interface ApiUserInformation {
  id?: string;
  sub?: string;
  email_verified?: boolean;
  emailVerified?: boolean;
  name?: string;
  preferred_username?: string;
  preferredUsername?: string;
  given_name?: string;
  firstName?: string;
  givenName?: string;
  family_name?: string;
  familyName?: string;
  lastName?: string;
  email?: string;
}

export class UserInformation {
  public id: string;
  public emailVerified: boolean;
  public name: string;
  public preferredUsername: string;
  public givenName: string;
  public familyName: string;
  public email: string;

  constructor(data: Partial<UserInformation> = {}) {
    this.id = data?.id ?? '';
    this.emailVerified = data?.emailVerified ?? false;
    this.name = data?.name ?? '';
    this.preferredUsername = data?.preferredUsername ?? '';
    this.givenName = data?.givenName ?? '';
    this.familyName = data?.familyName ?? '';
    this.email = data?.email ?? '';
    // Try to build name if not present in the response
    if (this.name === '' && this.givenName.length > 0 && this.familyName.length > 0) {
      this.name = `${this.givenName} ${this.familyName}`;
    }
  }

  public static createFromApi(data: ApiUserInformation = {}): UserInformation {
    return new UserInformation({
      id: data?.sub ?? data?.id ?? '',
      emailVerified: data?.email_verified ?? data?.emailVerified ?? false,
      name: data?.name ?? '',
      preferredUsername: data?.preferred_username ?? data?.preferred_username ?? '',
      givenName: data?.given_name ?? data?.givenName ?? data?.firstName ?? '',
      familyName: data?.family_name ?? data?.familyName ?? data?.lastName ?? '',
      email: data?.email ?? '',
    });
  }
}
